// Draft storage utilities for auto-save functionality

const DRAFT_KEY_PREFIX = 'onboarding_draft_';
const DRAFT_TIMESTAMP_KEY = 'onboarding_draft_timestamp_';

export const getDraftKey = (leadId) => {
  return leadId ? `${DRAFT_KEY_PREFIX}${leadId}` : `${DRAFT_KEY_PREFIX}general`;
};

export const getTimestampKey = (leadId) => {
  return leadId ? `${DRAFT_TIMESTAMP_KEY}${leadId}` : `${DRAFT_TIMESTAMP_KEY}general`;
};

export const saveDraft = (leadId, draftData) => {
  try {
    const draftKey = getDraftKey(leadId);
    const timestampKey = getTimestampKey(leadId);
    
    localStorage.setItem(draftKey, JSON.stringify(draftData));
    localStorage.setItem(timestampKey, new Date().toISOString());
    
    return true;
  } catch (error) {
    console.warn('Failed to save draft:', error);
    return false;
  }
};

export const loadDraft = (leadId) => {
  try {
    const draftKey = getDraftKey(leadId);
    const timestampKey = getTimestampKey(leadId);
    
    const draftData = localStorage.getItem(draftKey);
    const timestamp = localStorage.getItem(timestampKey);
    
    if (draftData && timestamp) {
      return {
        data: JSON.parse(draftData),
        timestamp: new Date(timestamp)
      };
    }
    
    return null;
  } catch (error) {
    console.warn('Failed to load draft:', error);
    return null;
  }
};

export const clearDraft = (leadId) => {
  try {
    const draftKey = getDraftKey(leadId);
    const timestampKey = getTimestampKey(leadId);
    
    localStorage.removeItem(draftKey);
    localStorage.removeItem(timestampKey);
    
    return true;
  } catch (error) {
    console.warn('Failed to clear draft:', error);
    return false;
  }
};

export const isDraftAvailable = (leadId) => {
  const draftKey = getDraftKey(leadId);
  return localStorage.getItem(draftKey) !== null;
};

export const getDraftAge = (leadId) => {
  const timestampKey = getTimestampKey(leadId);
  const timestamp = localStorage.getItem(timestampKey);
  
  if (!timestamp) return null;
  
  const draftTime = new Date(timestamp);
  const now = new Date();
  const ageInHours = (now - draftTime) / (1000 * 60 * 60);
  
  return ageInHours;
};

export const formatDraftAge = (ageInHours) => {
  if (ageInHours === null) return 'Unknown';
  
  if (ageInHours < 1) {
    const minutes = Math.floor(ageInHours * 60);
    return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
  } else if (ageInHours < 24) {
    const hours = Math.floor(ageInHours);
    return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
  } else {
    const days = Math.floor(ageInHours / 24);
    return `${days} day${days !== 1 ? 's' : ''} ago`;
  }
};